import axios from "axios";
import Environment from "../environment";
import * as localforage from "localforage";
import {Moment} from "moment";
import {message} from "antd";
import T from "./language";

export const sleep = (ms) => {
    return new Promise(resolve => setTimeout(resolve, ms));
}

export function formatPhoneNumber(phoneNumber) {
    return phoneNumber;
    // return (phoneNumber.substring(0, 3) + " " + phoneNumber.substring(3, 6) + " " + phoneNumber.substring(6)).trim();
}

export const cleanEmail = (inputString) => {
    const validCharactersRegex = /[a-zA-Z0-9@._-]/g;
    return ((inputString || "").match(validCharactersRegex) || [])?.join('');
}

export const getOrgCode = () => {
    return (window?.location?.host || "").split(".")[0]?.includes('-') ? (window?.location?.host || "").split(".")[0].split("-")[0] : "";
}

export const getLocalTimezone = () => {
    let timezoneOffset = new Date().getTimezoneOffset();
    let timezoneOffsetInHours = timezoneOffset / -60;
    const devTz = localStorage.getItem("DEV_TZ") ? parseFloat(localStorage.getItem("DEV_TZ")) : null;
    if (devTz?.toString()) {
        timezoneOffsetInHours = devTz;
    }
    return timezoneOffsetInHours || 0;
}

const createAxiosService = (url) => {
    const axiosInstance = axios.create({
        baseURL: url,
    });
    axiosInstance.interceptors.request.use((request) => {
        request.headers['x-api-key'] = Environment.apiKey;
        request.headers['original'] = `customer`;
        request.headers['tz'] = getLocalTimezone();
        // The customer app expects the URL to start with the company's
        // clientCode: e.g.  /demo/<shareUrlKey>. When the app is hosted under
        // a sub-path (PUBLIC_URL=/customer for staging without a domain) the
        // first pathname segment is `customer`, not the clientCode — strip
        // it so the client-code header is correct in both layouts.
        const segments = window.location?.pathname?.split("/").filter(Boolean) || [];
        const PUBLIC_BASE = (process.env.PUBLIC_URL || '').replace(/^\/+|\/+$/g, '');
        if (PUBLIC_BASE && segments[0] === PUBLIC_BASE) segments.shift();
        const clientCode = segments[0] && segments[0] !== "404" ? segments[0] : "";
        if (clientCode) {
            request.headers['client-code'] = clientCode;
        }
        request.headers['org-code'] = getOrgCode() || "icp";
        return request;
    });

    axiosInstance.interceptors.response.use(async (response) => {
        return response;
    }, async (error) => {
        if (error.response) {
            if (error?.response?.status === 503) {
                // @ts-ignore
                window?.setMaintenance?.();
            }
            return {
                status: error.response?.status || 400,
                data: error.response?.data,
            };
        }

        return Promise.reject(error);
    });
    return axiosInstance;
}

export const appService = createAxiosService(Environment.appServiceUrl);

export const getCampaignByUrl = (urlKey) => {
    return appService.post("/campaigns/customer/url", {
        shareUrlKey: urlKey
    })
}

export const preloadQuestionAndAnswer = async (campaignId, customerId) => {
    let result = {questions: null, answers: null};
    await Promise.all([getQuestions(campaignId).then(res => result.questions = res), getAnswers(customerId, 0)]).then(res => result.answers = res[1]);
    return result;
}

export const getQuestions = (campaignId) => {
    return appService.get("/questions/customer", {
        params: {campaignId: campaignId}
    })
}
export const postAnswers = (data) => {
    return appService.post("/answers/customer", data)
}
export const getAnswers = (customerId, packageIndex) => {
    return appService.get("/answers/customer", {params: {customerId, packageIndex}})
}
export const postBooking = (data) => {
    return appService.post("/bookings/customer", data)
}
export const postCampaignExcute = (data) => {
    return appService.post("/campaigns/customer/excute", data)
}
export const listSchedule = (campaignId, serviceId, fromDate, toDate) => {
    return appService.post('/campaigns/customer/schedules/list', {
        campaignId,
        serviceId,
        from: fromDate,
        to: toDate,
        limit: 99999
    })
}

export const getScheduleAvailable = (campaignId, serviceId, postalCode?: any) => {
    return appService.post('/campaigns/customer/schedules/list', {
        campaignId,
        serviceId,
        isAvaiable: true,
        limit: 99999,
        postalCode: postalCode || undefined
    })
}

export const getProductAndService = (campaignId, campaignPssId) => {
    return appService.post('/campaigns/customer/pss/detail', { campaignId, campaignPssId })
}
export const listProductAndService = (campaignId) => {
    return appService.post('/campaigns/customer/pss/list', { campaignId })
}
export const getAddressByPostalCode = (postalCode: string) => {
    return appService.post('/address/customer/lookup', { countryCode: 'SG', postalCode })
}

export const uploadBigFile = async (file: any, moduleName?: string) => {
    const result = await appService.get("/upload/customer/files", {
        // @ts-ignore
        params: {
            type: file.type,
            fileName: file.name,
            size: file.size,
            module: moduleName || "answers"
        }
    });
    const uploadUrl = result.data.data.uploadURL;
    const fileUri = result.data.data.Location;


    const fs = await new Promise(resolve => {
        let reader = new FileReader()
        reader.onload = (e: any) => {
            resolve(e.target.result);
        }
        reader.readAsArrayBuffer(file);
    });
    const resultUpload = await axios.put(uploadUrl, fs, {
        // @ts-ignore
        headers: {
            "Content-Type": file.type,
        }
    })

    const uploadData = resultUpload?.status === 200 ? result : resultUpload;
    let uploadViewData = await appService.post(`/upload/customer/read-files`, {
        url: uploadData?.data?.data?.Location
    });
    if (result?.data?.data && uploadViewData?.status === 200 && uploadViewData?.data?.data) {
        result.data.data.LocationView = uploadViewData.data.data;
    }

    return resultUpload.status === 200 ? {
        fileUri, fileUriView: uploadViewData?.data?.data
    } : {}
};

export const getClientConfig = () => {
    return appService.get(`/clients/configs`)
}


export function convertSvgToBase64Url(svgString) {
    const parser = new DOMParser();
    const svgDOM = parser.parseFromString(svgString, "image/svg+xml");

    const svgElement = svgDOM.documentElement;

    const serializer = new XMLSerializer();
    const svgXml = serializer.serializeToString(svgElement);

    const svgBytes = new TextEncoder().encode(svgXml);

    const base64String = btoa(String.fromCharCode.apply(null, svgBytes));

    const urlBase64 = "data:image/svg+xml;base64," + base64String;

    return urlBase64;
}

export function hexToRgbA(hex, alpha = 1) {
    let c;
    if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
        c = hex.substring(1).split('');
        if (c.length == 3) {
            c = [c[0], c[0], c[1], c[1], c[2], c[2]];
        }
        c = '0x' + c.join('');
        return 'rgba(' + [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(',') + ',' + alpha + ')';
    }
    return hex;
}

export const getAnswersLocal = (customerId, packageIndex) => {
    try {
        // Get local answer by packageIndex and customerId
        return JSON.parse(window.localStorage.getItem(`answers-${customerId}-${packageIndex}`))
    } catch (e) {
        return null;
    }
}

export const setAnswersLocal = (customerId, packageIndex, contents) => {
    try {
        // Save local answer by packageIndex and customerId
        window.localStorage.setItem(`answers-${customerId}-${packageIndex}`, JSON.stringify(contents))
    } catch (e) {
    }
}

export const wrapAnswersRemoteAndLocal = (answersRemote: Array<any>, answersLocal: Array<any>, questions: Array<any>) => {
    let result = answersRemote;
    try {
        // If remote answers is empty and local answers is not empty, return local answers
        if (!answersRemote?.length && !!answersLocal?.length) {
            result = answersLocal;
        }

        // update answers by questions
        if (questions?.length && answersLocal) {
            // Fill local answers with questions
            questions.map(question => {
                const answerLocal = answersLocal.find(answer => answer.questionId === question.id);
                // If answer is not found in remote answers, add local answer to result
                if (!!answerLocal && !result.find(answer => answer.questionId === question.id)) {
                    result.push(answerLocal)
                }
            })

            result = result.map(answer => {
                const question = questions.find(q => q.id === answer.questionId);
                // Update answer options by question options
                if (question) {
                    if (["single-selection", "multiple-selection", "search-selection"].includes(question.type)) { // Update options
                        answer.options = answer.options.filter(option => !!(question.options || []).find(qo => qo.key === option.key))
                    }
                    return answer;
                }
                return null;
            }).filter(answer => !!answer);


        }
    } catch (e) {
    }
    return result;
}

export const CacheScheduleService = {
    get: async (date: Moment, customerId: string) => {
        return await localforage.getItem(`cache-schedule-${date.format("YYYY-MM")}-${customerId}`);
    },
    set: async (date: Moment, customerId: string, value) => {
        return await localforage.setItem(`cache-schedule-${date.format("YYYY-MM")}-${customerId}`, value);
    },
    clear: async () => {
        const keys = await localforage.keys();
        const prefix = 'cache-schedule-';
        const keysToRemove = keys.filter(key => key.startsWith(prefix));
        const removalPromises = keysToRemove.map(key => localforage.removeItem(key));
        return Promise.all(removalPromises);
    }
};

export const singleClick = (func) => {
    // @ts-ignore
    const lastClick = window.lastClick || 0;
    const now = new Date().getTime();
    if (now - lastClick < 500) {
        return;
    }
    // @ts-ignore
    window.lastClick = now;
    func();
}

export const decodeUri = (uri) => {
    try {
        if (!uri) return uri;
        return window?.decodeURIComponent(uri || "");
    } catch (e) {
        console.log("Decode uri error:", e.message);
        console.log("URI:", uri);
        return uri;
    }
}


export function fileUrlExacter(url) {
    if (!!url && typeof url === 'string') {
        url = decodeUri((url || "").toString() || "");
        // replace ?
        url = url.replace(/%3F/g, '?');
        const token = url.split('?')[1];
        const originUrl = url.split('?')[0] || "";
        const fileName = originUrl.toString().split('/').pop();
        const type = originUrl.toString().split('.').pop();
        return {
            originUrl,
            fileName,
            type,
            token
        }
    }
    return null
}

export const getFileView = async (uri) => {
    return appService.post(`/upload/customer/read-files`, {
        url: uri
    });
}

export const getSettings = async () => {
    return axios({
        baseURL: Environment.appServiceUrl,
        url: `/settings`,
        method: 'GET',
        headers: {
            "x-api-key": Environment.apiKey,
            "original": "customer",
            "tz": getLocalTimezone(),
            "org-code": getOrgCode() || "icp"
        }
    })
}

export const postChatStart = (bookingId: string) => {
    return appService.post(`/chats/customer/start`, {
        bookingId: bookingId
    });
}

export const getChatUserToken = async (bookingId: string, tencentUserId: string) => {
    return appService.post(`/chats/customer/gen-sig`, {
        bookingId: bookingId || undefined,
        tencentUserId: tencentUserId
    });
}


export const postChatMessage = async (data: {
    "bookingId": string,
    "tencentUserId": string,
    "contents"?: string, // Nếu có contents thì không có mediaUrls và mediaCaption
    "mediaUrls"?: Array<string>, // Nếu có mediaUrls thì không có contents
    "mediaCaption"?: string // chỉ có khi gửi media, (optional: có hoặc không)
}) => {
    return appService.post(`/chats/customer`, data);
}

export const getChatMessages = async (bookingId: string, params: any) => {
    return appService.get(`/chats/customer/histories`, {
        params: {
            bookingId: bookingId,
            ...params
        }
    });
}

export const postJoinChat = async (bookingId: string, threadId: string) => {
    return appService.post(`/chats/customer/join`, {
        bookingId: bookingId,
        threadId: threadId
    });
}

export const postJoinCall = async (threadId: string) => {
    return appService.post(`/chats/customer/join-call`, {
        threadId: threadId
    });
}

export const getCallUsers = async (threadId: string) => {
    const result = await appService.post('/chats/customer/detail', { threadId });
    if (result?.status === 200 && result?.data?.data) {
        return result?.data?.data?.callInfo?.users || {};
    }
    return {};
}

export const addCallUser = async (threadId: string, userName: string) => {
    return appService.post(`/chats/customer/call/add-user`, {threadId, userName}).catch(reason => null);
}

export const delCallUser = async (threadId: string, userName: string) => {
    return appService.put(`/chats/customer/call/remove-user`, {threadId, userName}).catch(reason => null);
}

export const getThreadDetail = (threadId: string) => {
    return appService.post('/chats/customer/detail', { threadId });
}

export const putUpdateCallInfoProfile = async (threadId: string, value: any) => {
    let currentCallInfo: any = {};
    const result = await appService.post('/chats/customer/detail', { threadId });
    if (result?.status === 200 && result?.data?.data) {
        currentCallInfo = result.data.data.callInfo || {};
        return appService.put('/chats/customer/update', {
            threadId,
            callInfo: {
                ...currentCallInfo,
                users: {
                    ...(currentCallInfo?.users || {}),
                    ...value
                }
            },
        });
    }
    return null;
}

export const popUpdateCallInfoProfile = async (threadId: string, userName: string) => {
    let currentCallInfo: any = {};
    const result = await appService.post('/chats/customer/detail', { threadId });
    if (result?.status === 200 && result?.data?.data) {
        currentCallInfo = result.data.data.callInfo || {};
        let currentUsers = currentCallInfo?.users || {};
        if (currentUsers[userName]) {
            delete currentUsers[userName];
        }
        return appService.put('/chats/customer/update', {
            threadId,
            callInfo: {
                ...currentCallInfo,
                users: currentUsers
            },
        });
    }
    return null;
}

export const getHtmlText = (html) => {
    let tempDiv = document.createElement("div");
    tempDiv.innerHTML = html || "";
    return tempDiv.textContent || tempDiv.innerText || "";
}

export const postSendEmail = (data) => {
    return appService.post("/email-templates/customer/send", data);
}

export const postChatAnonymousStart = (data) => {
    return appService.post(`/chats/customer/start`, data, {
        params: {
            type: "anonymous"
        }
    });
}
